var AdaptiveImage = require("../../../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js").default;

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "static/media/dashedLine.1c4b4919.png",
    width: 4,
    height: 103
});